import React, { Component } from 'react'
import CloseIconWhite from 'assets/icons/close-icon-white.png'
import UserAvatarContainer from 'src/components/common/UserAvatarContainer'
import { connect } from 'react-redux'
import { userSelector } from 'src/selectors'
import IcoPoll from 'assets/icons/ico-poll.png'
import BalloonIconWhite from 'assets/icons/balloon-icon-white.png'
import Button from 'components/common/Button'
import PropTypes from 'prop-types'
import { setUserId } from 'src/actions'
import jsCookie from 'js-cookie'
import { routerActions } from 'react-router-redux'
import styles from './menu.scss'

class Menu extends Component {
  handleLogOut = () => {
    const { onRemoveUserId, onClose, user, onChangeRouter } = this.props

    if (user) {
      onRemoveUserId()
      jsCookie.remove('access_token')
      jsCookie.remove('refresh_token')
    } else {
      onChangeRouter('/tp/login')
    }

    onClose()
  }

  navigationTab = type => {
    const { onClose, onChangeRouter } = this.props

    if (type === 'event') {
      onChangeRouter('/e/list')
    } else {
      onChangeRouter('/tp/timepoll')
    }

    onClose()
  }

  render() {
    const { user, onClose } = this.props

    return (
      <div className={styles['menu-container']}>
        <div className={styles['mask']} onClick={onClose} />
        <div className={styles['menu-wrapper']}>
          <div className={styles['avatar-container']}>
            <img src={CloseIconWhite} width="20" onClick={onClose} />
            <div className={styles['avatar']}>
              <UserAvatarContainer user={user || {}} size={50} borderColor="#2cd4ae" />
              <div>
                {user?.first_name} {user?.last_name}
              </div>
            </div>
          </div>
          <ul className={styles['list-container']}>
            <li className={styles['list-item']} onClick={() => this.navigationTab('poll')}>
              <img src={IcoPoll} alt="" />
              <span>Polls & Lists</span>
            </li>
            <li className={styles['list-item']} onClick={() => this.navigationTab('event')}>
              <img src={BalloonIconWhite} alt="" />
              <span>Events</span>
            </li>
          </ul>
          <div className={styles['button-wrapper']}>
            <Button className={styles['button-inner']} onClick={this.handleLogOut}>
              {user ? 'LOG OUT' : 'LOGIN'}
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

Menu.propTypes = {
  user: PropTypes.object,
  onRemoveUserId: PropTypes.func,
  onClose: PropTypes.func,
  onChangeRouter: PropTypes.func
}

function mapDispatchToProps(dispatch) {
  return {
    onRemoveUserId: () => dispatch(setUserId('')),
    onChangeRouter: route => dispatch(routerActions.push(route))
  }
}

function mapStateToProps(state) {
  return {
    user: userSelector(state)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu)



// WEBPACK FOOTER //
// ./src/components/common/HeaderBar/Menu/Menu.jsx